<template>
    <div id="dContainer" class="row">

        <div class="col-sm-12 col-md-6 my-5" v-for="(group, key, index) in groups" :key="index">

            <div class="row">
                <div class="col-3 col-md-3 col-lg-2">
                    <img class="img-thumbnail" style="width: 100%" :src="group[0].image || 'https://3.cdnpt.com/images/L2/noImageAvailable.png'" :alt="group[0].stateName">
                </div>

                <div class="col-9 col-md-9  col-lg-10">
                    <h3 class="text-capitalize font-weight-bold"> {{ key | uppercase  }}</h3>
                    <div class="row">

                        <div class="col-12">
                            <div class="row">
                                <div class="col-md-6" v-for="(destination, indexGroup) in group" :key="destination.id" :class="{ 'd-none':  itemDisplay[index] && indexGroup >= itemDisplay[index].value }">
                                    <a class="link" :href="`${siteConfig.siteUrl}/${culture.cultureCode}/${__('url.url_destination')}/${destination.uri}`">{{ destination.display }}</a>
                                    <p class="nm light">{{ destination.hotelCount }} {{__('messages.hotels')}}</p>
                                </div>
                            </div>

                        </div>



                    </div>

                </div>
                <div class="col-12 col-md-3  col-lg-2"></div>
                <div class="col-12 col-md-9  col-lg-10" v-if="itemDisplay && itemDisplay[index] &&  itemDisplay[index].value">
                    <button type="button" class="btnTertiary btnTertiary--md" v-if="group.length > 4" @click="show(index)"> {{ itemDisplay[index].value == 4 ? __('messages.see_more') : __('messages.see_less')}} </button>
                </div>

            </div>



        </div>

    </div>
</template>


<script>
    const site = window.__pt.settings.site;

    export default {
        props: ['groups'],
        data() {
            return {
                showAll: false,
                siteConfig: site,
                culture: window.__pt.cultureData,
                itemDisplay: []
            };
        },
        computed: {
  
        },

        async mounted() {
            this.initialize();
        },

        methods: {
            show(key) {

                this.itemDisplay[key].value = this.itemDisplay[key].value == 4 ? 1000 : 4;

            },

            initialize() {

                for (let group in this.groups) {
                    this.itemDisplay.push({
                        key: group,
                        value: 4
                    });
                }

            }

        }
    };
</script>


<style>
    .additional-destinations {
        height: 0;
        overflow: hidden;
        transition: height 0.3s ease-out;
    }

        .additional-destinations.collapsed {
            height: auto;
        }
</style>

